module.exports = __webpack_public_path__ + "static/media/snow-tire-installation.5ed20e2f.svg";